import React from 'react';

export type TabPageProps = React.PropsWithChildren<{
    index: number,
    tabIndex: number
}>

export function TabPage ({ index, tabIndex, children }: TabPageProps) {
    return (
        <React.Fragment>
            { index === tabIndex && children }
        </React.Fragment>
    )
}